<p-calendar [(ngModel)]="ngValue" [showIcon]="true"></p-calendar>